import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Row, DropdownMenu, DropdownItem, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { GET_VendorDashboard } from "../../slices/thunks";

const RecentOrders = () => {
  const navigate = useNavigate();
  const data = useSelector((state) => state.VendorDashboard.data);
  const dispatch = useDispatch();
  let url= window.location.pathname;
  useEffect(() => {
    dispatch(GET_VendorDashboard());
  }, [dispatch]);

  const recentOrders = data?.record || [];

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "won":
        return "badge bg-success-subtle text-success";
      case "expired":
        return "badge bg-danger-subtle text-danger";
      case "lost":
        return "badge bg-light-subtle text-muted";
      default:
        return "badge bg-warning-subtle text-warning";
    }
  };

  const handleRowClick = (order) => {
    navigate(`/Order-details?${order.plant.documentNumber}`, { state: { order } });
  };

  return (
    <React.Fragment>
      <Card>
        {(url !== "/Quotation-register") ? <CardHeader className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Recent Orders</h4>
          <div className="text-muted">{recentOrders.length}</div>
        </CardHeader> :<></>}

        <CardBody>
          <div>
            {recentOrders.map((order, key) => (
              <Row
                className="g-0 mb-2"
                key={key}
                style={{
                  marginBottom: "0rem", // Reduced margin
                  padding: "0rem", // Reduced padding
                }}
              >
                <Col>
                  <Card style={{ fontSize: "0.9rem" }}> {/* Smaller font size for compactness */}
                    <CardHeader
                      className="p-1" // Reduced padding
                      onClick={() => handleRowClick(order)}
                      style={{
                        cursor: "pointer",
                        fontSize: "0.85rem", // Adjusted font size
                      }}
                    >
                      {/* First Line: Vendor Name */}
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6
                          className="flex-grow-1 mb-0 text-truncate"
                          style={{
                            fontSize: "1rem", // Smaller font for compact layout
                            fontWeight: "bold",
                          }}
                        >
                          {order.vendor.name}
                        </h6>

                        {/* Dropdown */}
                        <div className="d-flex align-items-center">
                          <span
                            className={`badge ${getStatusClass(order.plant.status)} me-1`}
                            style={{
                              fontSize: "0.65rem", // Smaller badge text
                              padding: "0.2rem 0.4rem", // Compact badge padding
                            }}
                          >
                            {order.plant.status || "Pending"}
                          </span>
                          <UncontrolledDropdown>
                            <DropdownToggle
                              tag="button"
                              className="btn btn-info btn-sm dropdown"
                              type="button"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <i className="ri-more-fill"></i>
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem>
                                <i className="ri-check-fill align-bottom me-2 text-success"></i>
                                Approve
                              </DropdownItem>
                              <DropdownItem>
                                <i className="ri-close-fill align-bottom me-2 text-danger"></i>
                                Reject
                              </DropdownItem>
                              <DropdownItem>
                                <i className="ri-whatsapp-fill align-bottom me-2 text-success"></i>
                                WhatsApp
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                      </div>

                      {/* Second Line: Order Items */}
                      <div className="d-flex justify-content-between align-items-center mb-1 text-muted">
                        <small className="flex-grow-1 mb-0 text-truncate">
                          {order.items.length > 1 ? (
                            <>
                              {order.items[0].name} + {order.items.length - 1} more items
                            </>
                          ) : (
                            order.items[0].name
                          )}
                        </small>
                      </div>

                      {/* Third Line: Details and Total Amount */}
                      <div className="d-flex flex-wrap justify-content-between align-items-center">
                        {/* Quantity */}
                        <Col
                          className="d-flex align-items-center me-2 mb-1"
                          style={{
                            minWidth: "100px", // Reduced width
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <i className="ri-shopping-cart-line text-primary me-1"></i>
                          <span>
                            {order.items.reduce((total, product) => total + product.RequiredQuantity, 0)} Pcs
                          </span>
                        </Col>

                        {/* Date */}
                        <Col
                          className="d-flex align-items-center me-2 mb-1"
                          style={{
                            minWidth: "100px", // Reduced width
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <i className="ri-time-line text-primary me-1"></i>
                          <span>{moment.utc(order.plant.date).local().format("DD/MM/YYYY hh:mm A")}</span>
                        </Col>

                        {/* Total Amount */}
                        <Col
                          className="d-flex align-items-center"
                          style={{
                            minWidth: "100px", // Adjusted width
                            justifyContent: "flex-end",
                            fontSize: "1rem", // Reduced font size for compactness
                            fontWeight: "bold",
                            whiteSpace: "nowrap", // Prevents wrapping
                            overflow: "hidden", // Prevents overflow
                            textOverflow: "ellipsis", // Adds ellipsis for overflow
                          }}
                        >
                          ₹ {order.items.reduce((total, product) => total + product.amount, 0)}
                        </Col>
                      </div>

                    </CardHeader>
                  </Card>
                </Col>
              </Row>
            ))}

          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default RecentOrders;
